// Module
var code = `<span></span>
<div class="line"></div>
`;
// Exports
module.exports = code;